<template>
  <b-modal id="PaymentModel" centered>
    <template v-slot:modal-header="{ }">
      <!-- Emulate built in modal header close button action -->
      <h5>{{product}}</h5>
    </template>
    <p class="text-center">
      {{ product }}消費扣 {{ point }}點
    </p>
    <template v-slot:modal-footer="{ cancel }">
      <div class="mx-auto">
        <b-button pill size="lg" variant="outline-danger mr-3" @click="cancel()">
          取消
        </b-button>
        <b-button pill size="lg" variant="success" class="text-center" @click="ok2()" >
          確定
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>

export default {
  name: 'PaymentModel',
  props: {
    product:String,
    point:String,
  },
  data() {
    return {

    }
  },
  methods: {
    ok2(){
      this.$bvModal.hide('PaymentModel')
      this.$emit('sendAction');
    }

  }
}
</script>
